var exports = {
  "F": "menuAnchorButton__l472Vu",
};

module.exports = exports;
